// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PartitionOutlinedSvg from "@fishx/icons-svg/es/asn/PartitionOutlined";
import FishxIcon from '../components/FishxIcon';

var PartitionOutlined = function PartitionOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PartitionOutlinedSvg
  }));
};

PartitionOutlined.displayName = 'PartitionOutlined';
export default React.forwardRef(PartitionOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PartitionOutlined.js
// module id = 3747
// module chunks = 0